import { Popover, Typography, Button } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { Container } from "./styles";

const EmailInfoPopover = ({
  autoOpen,
  message,
  customContainerStyle,
}: {
  autoOpen: boolean;
  message: string;
  customContainerStyle?: React.CSSProperties;
}) => {
  const [open, setOpen] = useState<boolean>(autoOpen);
  const openerRef = useRef<HTMLSpanElement | null>(null);
  const [anchor, setAnchor] = useState<Element | null>(null);

  useEffect(() => {
    openerRef.current && setAnchor(openerRef.current as Element | null);
  }, []);

  return (
    <>
      <span
        ref={openerRef}
        style={{
          position: "absolute",
          right: 0,
        }}
      ></span>
      {anchor && (
        <Popover
          open={open}
          anchorEl={anchor}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: 141, horizontal: 10 }}
          PaperProps={{
            style: {
              boxShadow: "none",
              backgroundColor: "transparent",
            },
          }}
        >
          <Container style={{ ...customContainerStyle }}>
            <Typography variant="body2">{message}</Typography>
            <Button
              variant="contained"
              style={{
                width: "fit-content",
                alignSelf: "end",
              }}
              onClick={() => {
                setOpen(false);
              }}
            >
              <Typography variant="body2">Okay</Typography>
            </Button>
          </Container>
        </Popover>
      )}
    </>
  );
};

export default React.memo(EmailInfoPopover);
